import React from 'react';

import PostLayout from '../../../../Layout/PostLayout';
import CommunicationShow from '.';
import PostSidePrimaryActions from './PostSidePrimaryActions';
import EventFooter from './EventFooter';
import { isEvent } from '../../../../Utils/Post';
import { Post } from '../../../../Utils/Types/Posts';
import { Space } from '../../../../Utils/Types/Space';

interface CommunicationWrapperProps {
  post: Post;
  space: Space;
}

function Communication({ post, space }: CommunicationWrapperProps) {
  return (
    <PostLayout
      post={post}
      postMainContent={<CommunicationShow post={post} space={space} />}
      postSideContent={isEvent(post.type) && <PostSidePrimaryActions post={post} />}
      stickyFooterButton={isEvent(post.type) && <EventFooter post={post} />}
    />
  );
}

export default Communication;
